import { MultiprintModule } from './../multiprint/multiprint.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NotificationsModule } from '@notifications/notifications.module';
import { SharedModule } from '@shared/shared.module';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { AuthRequestInterceptor } from './interceptors/auth-request.interceptor';
import { AuthResponseInterceptor } from './interceptors/auth-response.interceptor';
import { ReportProblemModalComponent } from './modals/report-problem-modal/report-problem-modal.component';
import { AccountSharedModule } from '@shared/modules/account/account-shared.module';
import { ErrorCodeInterceptor } from './interceptors/error-code.interceptor';
import { TwoFactorConfigModalComponent } from './modals/two-factor-config-modal/two-factor-config-modal.component';
import { QrCodeModule } from 'ng-qrcode';
import { PreviewModule } from '@preview/preview.module';
import { SessionReplacedModalComponent } from './modals/session-replaced-modal/session-replaced-modal.component';


@NgModule({
  declarations: [
    ContextMenuComponent,
    NavMenuComponent,
    SideMenuComponent,
    FooterComponent,
    ReportProblemModalComponent,
    TwoFactorConfigModalComponent,
    SessionReplacedModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccountSharedModule,
    NotificationsModule,
    MultiprintModule,
    QrCodeModule,
    PreviewModule
  ],
  exports: [
    NavMenuComponent,
    SideMenuComponent,
    FooterComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthResponseInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCodeInterceptor,
      multi: true
    },
  ]
})
export class CoreModule { }
